module.exports = __webpack_public_path__ + "img/106.8.4a50cf48.png";